/**
 * Endpoints del módulo **Bonus** (`/api/bonus/solicitudes`).
 *
 * Las cuatro pantallas son el mismo listado con un `tipo` distinto: el
 * `request_url` que `bonus_request` guarda por cada operación contra el servicio
 * de Primax (transacciones, balance, acumular y canje).
 */

import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

import type { BonusSolicitudesRespuesta } from './bonus.types';

/** Tipos de operación que el panel anterior ofrecía en sus pantallas. */
export const TIPOS_BONUS = {
  transacciones: 'transactions/api/v3/transaction',
  balance: 'loyalty/api/v2/Balance',
  acumular: 'loyalty/api/v2/Accumulate',
  canje: 'loyalty/api/v2/Exchange/card',
} as const;

export type TipoBonus = (typeof TIPOS_BONUS)[keyof typeof TIPOS_BONUS];

export const bonusKeys = {
  all: ['bonus'] as const,
  solicitudes: (tipo: string) => ['bonus', 'solicitudes', tipo] as const,
};

export const bonusApi = {
  solicitudes: (tipo: string, signal?: AbortSignal): Promise<BonusSolicitudesRespuesta> =>
    apiClient.get<BonusSolicitudesRespuesta>('/api/bonus/solicitudes', {
      signal,
      query: { tipo },
    }),
};

/** Historial de solicitudes de un tipo de operación Bonus. */
export function useSolicitudesBonus(tipo: string) {
  return useQuery({
    queryKey: bonusKeys.solicitudes(tipo),
    queryFn: ({ signal }) => bonusApi.solicitudes(tipo, signal),
    staleTime: 15_000,
  });
}
